// extracted by mini-css-extract-plugin
module.exports = {"header":"Profile--styles-module_header-2Fx4I","headerPhoto":"Profile--styles-module_headerPhoto-Ft_5O","editButton":"Profile--styles-module_editButton-1lknE"};